// store.js
// - On the live site (Netlify): PublicSite reads directly from the JSON files
//   in src/data/ at build time. This store is only used by AdminDashboard locally.
// - When running locally (npm start): AdminDashboard uses localStorage as a
//   scratchpad. When you're happy with your changes, click "Export & Save" in
//   the admin to write the data back to src/data/products.json and src/data/site.json.
//   Then push to GitHub and Netlify will rebuild with the new data.

const store = {
  async get(key) {
    try {
      const raw = localStorage.getItem("jc_" + key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  async set(key, val) {
    try {
      localStorage.setItem("jc_" + key, JSON.stringify(val));
    } catch (e) {
      console.error("Storage error:", e);
    }
  },
  async remove(key) {
    try {
      localStorage.removeItem("jc_" + key);
    } catch (e) {
      console.error("Storage error:", e);
    }
  }
};

export default store;
